import genericAvatar from "assets/images/generic_avatar.jpg";
import { ErrorModal, PageContainer } from "components";
import { variants } from "components/AnimatedRoutes";
import { StudentTeacherSecondaryInfo } from "components/reusables";
import { AddEditStudentTeacherModal } from "components/reusables/AddEditModals/AddEditStudentTeacherModal";
import { motion } from "framer-motion";
import React, { useCallback, useState } from "react";
import { useAsync } from "react-async";
import { Button, Card, Col, Row, Spinner } from "react-bootstrap";
import Img from "react-cool-img";
import { Redirect, useHistory, useParams } from "react-router-dom";
import { getStudentTeacherStory } from "services";
import { generateFullName, URLPaths } from "utilities";

export function PictureWallStudentTeacherStoryDetails(): JSX.Element {
  const { id } = useParams<{ id: string }>();
  const [isShowingEditStudentTeacherModal, setIsShowingEditStudentTeacherModal] = useState(false);
  const promiseFn = useCallback(() => getStudentTeacherStory(id), [id]);
  const { data, error, isPending } = useAsync({ promiseFn });
  const teacher = data;
  const history = useHistory();

  const handleClick = () => {
    history.goBack();
  };

  if (!teacher && !isPending) return <Redirect to={URLPaths.pictureWall} />;

  return (
    <motion.div
      variants={variants}
      initial="jobenter"
      animate="jobcenter"
      exit="jobexit"
      transition={{
        x: { bounce: 0, duration: 0.5, type: "spring" },
      }}
    >
      <PageContainer>
        <div
          style={{
            backgroundColor: "#FFFFFF",
            borderColor: "#000000",
            borderRadius: "10px",
            padding: "45px",
            paddingTop: "40px",
            position: "relative",
            top: "-45px",
          }}
        >
          {isPending ? (
            <Spinner animation="border" />
          ) : (
            teacher && (
              <Row>
                <Col xs={3}>
                  <Img
                    src={teacher.photoUrl || ""}
                    placeholder={genericAvatar}
                    alt={`${teacher.firstName} ${teacher.lastName}`}
                    width="100%"
                    loading="lazy"
                    className="img-circle"
                  />
                  <hr />
                  <StudentTeacherSecondaryInfo studentTeacher={teacher} direction="column" />
                  <hr />
                  {/* <StudentTeacherContactInfo teacher={teacher} /> */}
                </Col>
                <Col>
                  <Row>
                    <Col>
                      <h1>
                        {generateFullName(teacher.firstName, teacher.lastName)} (Student-Teacher){" "}
                      </h1>
                      <span>{`Class of ${teacher.gradYear}`}</span>
                    </Col>

                    <Col xs="auto">
                      <Button onClick={handleClick} variant="outline-danger">
                        Go Back
                      </Button>
                    </Col>
                  </Row>
                  <hr />
                  <Row>
                    <Col xs={10}>
                      {(teacher.quotes || []).length > 0 && (
                        <>
                          <h4>Quotes</h4>
                          <Card className="quotes">
                            <Card.Body>
                              {teacher.quotes?.map(quote => (
                                <StudentTeacherQuote key={quote} quote={quote} />
                              ))}
                            </Card.Body>
                          </Card>
                        </>
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            )
          )}
          <ErrorModal error={error} />
        </div>

        {!!teacher && (
          <AddEditStudentTeacherModal
            show={isShowingEditStudentTeacherModal}
            setShow={setIsShowingEditStudentTeacherModal}
            currentTeacher={teacher}
          />
        )}
      </PageContainer>
    </motion.div>
  );
}

interface StudentTeacherQuoteProps {
  quote: string;
}

function StudentTeacherQuote({ quote }: StudentTeacherQuoteProps): JSX.Element {
  return (
    <div className="quote d-flex flex-row">
      <span>&quot;{quote}&quot;</span>
    </div>
  );
}
